import { render, staticRenderFns } from "./ParkingAccessRecord.vue?vue&type=template&id=10b8dcc4"
import script from "./ParkingAccessRecord.vue?vue&type=script&lang=js"
export * from "./ParkingAccessRecord.vue?vue&type=script&lang=js"
import style0 from "./ParkingAccessRecord.vue?vue&type=style&index=0&id=10b8dcc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports